if (!customElements.get('product-description')) {
  customElements.define('product-description', class ProductDescription extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.product-description__viewport');
      this.content = this.querySelector('.product-description__content');
      this.button = this.querySelector('.product-description__toggle');
      this.label = this.button.querySelector('span');
      this.expanded = false;
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.button.addEventListener('click', () => this.toggle(), { signal });
      // Reveal links reached by keyboard so focus never stays in clipped content.
      this.content.addEventListener('focusin', () => {
        if (!this.expanded && !this.button.hidden) this.toggle();
      }, { signal });
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.content);
      this.measure();
    }

    measure() {
      const style = getComputedStyle(this.content);
      const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
      this.previewHeight = lineHeight * 3;
      this.fullHeight = this.content.getBoundingClientRect().height;
      this.button.hidden = this.fullHeight <= this.previewHeight + 1;
      this.viewport.style.height = `${this.expanded || this.button.hidden ? this.fullHeight : this.previewHeight}px`;
    }

    toggle() {
      const startHeight = this.viewport.getBoundingClientRect().height;
      this.animation?.cancel();
      this.expanded = !this.expanded;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.label.textContent = this.expanded ? this.button.dataset.readLess : this.button.dataset.readMore;
      this.measure();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.animation = this.viewport.animate(
          [{ height: `${startHeight}px` }, { height: this.viewport.style.height }],
          { duration: 350, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      this.animation?.cancel();
    }
  });
}
